import { IContactTopic } from '../../interfaces/contact/IContactTopic.ts';

export const CONTACT_TOPICS: IContactTopic[] = [
    { id: 'TechSupport', label: 'Problem techniczny' },
    { id: 'PlatformSuggestions', label: 'Rozwój platformy - sugestie' },
    { id: 'Other', label: 'Inny' },
];